import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../../../../hooks/useAuth'

import styles from './student.admin.module.scss'

import { AlunoRepository } from '../../repositories/aluno.repository'
import { Aluno } from '../../entities/aluno.entity'

import { StudentList } from './parts/student'
import { Documents } from './parts/documents'
import { formatStudent } from './@utils'
import { Registration } from './parts/registration'
import { Loader } from '@/components/Loader'

export interface IRegistration {
  institution: string
  course: string
  status: string
  category: string
  statuspagamento: string
  titulo: string
  id: number
  url_imagem: string
  shift: string
}

export type ViewType =
  | 'STUDENT'
  | 'DOCUMENTS'
  | 'ADD DOCUMENT'
  | 'REGISTRATIONS'
  | 'VER REGISTRATIONS'

export function AlunoPage() {
  const { id } = useParams()
  const { token } = useAuth()
  const [loading, setLoading] = useState(false)
  const [student, setStudent] = useState({} as Aluno)
  const [registrations, setRegistrations] = useState<IRegistration[]>([])
  const [view, setView] = useState<ViewType>('STUDENT')
  const [registration, setRegistration] = useState({} as IRegistration)

  const navigate = useNavigate()

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)
      const { data } = await AlunoRepository.GetInstance().adminFindById(
        token,
        id,
      )
      setRegistrations([data.registrations])

      const formattedStudent: Aluno = formatStudent(data.student)
      setStudent(formattedStudent)
    } catch (error) {
      console.error('error: ', error)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div className={styles.container}>
      {loading && <Loader />}
      <div className={styles.header_buttons}>
        <button onClick={() => setView('STUDENT')}>Aluno</button>
        <button onClick={() => setView('DOCUMENTS')}>Documentos</button>
        <button onClick={() => setView('REGISTRATIONS')}>Inscrições</button>
      </div>

      {view == 'STUDENT' && <StudentList student={student} />}

      {(view == 'DOCUMENTS' || view == 'ADD DOCUMENT') && (
        <Documents setView={setView} view={view} />
      )}

      {view == 'REGISTRATIONS' && (
        <Registration
          registrations={registrations}
          setRegistration={setRegistration}
          setView={setView}
        />
      )}

      {!registration?.id && !registration && (
        <div className={styles.inscricaoValueContainer}>
          <p>INSCRIÇÃO</p>
          <div>
            <p>CURSO:</p> <p>{registration.titulo}</p>
          </div>
          <div>
            <p>STATUS:</p> <p>{registration.status}</p>
          </div>
          <div>
            <p>STATUS PAGAMENTO:</p> <p>{registration.statuspagamento}</p>
          </div>
          <a
            href=""
            onClick={() => navigate(`/institution/${registration.id}`)}
          >
            Ir para Instituição
          </a>
        </div>
      )}
    </div>
  )
}
